import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import { vignettePreview_template } from "./vignettePreview_template";
import { vignettePreview_helper } from "../../modules/vignettePreview_helper";
import { login } from "../../modules/login";
import { isColor, isPercent } from "@amcharts/amcharts4/core";

declare var ko: any;

export class configPromotionsEdit_template extends vnTemplate {

    protected filterLoginStatus: filterDropdown_template;
    protected filterPreimumStatus: filterDropdown_template;
    protected filterAdBlockStatus: filterDropdown_template;
    protected filterBotRequestStatus: filterDropdown_template;
    protected filterListStatus: filterDropdown_template;
    protected filterPushNotificationStatus: filterDropdown_template;
    protected filterHighEngagementStatus: filterDropdown_template;
    protected presetsFilter: filterDropdown_template;
    public filterGEO: filterAutocomplete_template;
    protected vignettePreview: vignettePreview_template;
    protected vignettePreviewHelper: vignettePreview_helper;

    protected getTemplateHtml(): string {
        return `
            <div class="w-form w-form-large">

                <div class="form-header">
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <input type="checkbox" id="isAvailable" data-bind="checked:isAvailable">
                            <label for="isAvailable" class="form-label icon i-check">Is Available For Use</label>
                        </div>

                         <div class="form-group">
                            <label for="name" class="form-label">Name</label>
                            <input id="name" data-bind="value: name" type="text" class="input-text">
                        </div>

                        <strong class="form-sub-title no-margin">Content</strong>

                        <div class="form-group">
                            <input type="radio" id="custom" data-bind="checked:contentType, checkedValue: 'custom'">
                            <label for="custom" class="form-label icon i-check">Custom HTML & CSS</label>
                        </div>

                         <div class="form-group">
                            <input type="radio" id="presets" data-bind="checked:contentType, checkedValue: 'preset'">
                            <label for="presets" class="form-label icon i-check">Presets</label>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label for="name" class="form-label">Login User Condition</label>
                            `+ this.filterLoginStatus.getHtmlBuild() +`
                        </div>

                        <div class="form-group">
                            <label for="name" class="form-label">Premium User Condition</label>
                            `+ this.filterPreimumStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <label for="name" class="form-label">Ad Block User Condition</label>
                            `+ this.filterAdBlockStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <label for="name" class="form-label">Is Bot Request Condition</label>
                            `+ this.filterBotRequestStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <label for="name" class="form-label">List User Condition</label>
                            `+ this.filterListStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <!-- <label for="geos" class="form-label">GEOs</label> -->
                            <div class="form-group" style="margin: 0;">
                                ` + this.filterGEO.getHtmlBuild() + `
                            </div>
                            <div class="form-group" data-bind="foreach: geos" style="margin-top: 5px;">
                                <div class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickRemoveGeo}" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>
                            <!-- <small class="form-text" style="display: block; color: #666;">Leave empty to allow all GEOs.</small>-->
                            <label for="name" class="form-label">Push Notifications Condition</label>
                            `+ this.filterPushNotificationStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <label for="name" class="form-label">High Engagement Condition</label>
                            `+ this.filterHighEngagementStatus.getHtmlBuild() +`
                        </div>
                        <div class="form-group">
                            <label for="tagNameRuleRegex" class="form-label">Tag Name Rule Regex</label>
                            <input id="tagNameRuleRegex" data-bind="value: tagNameRuleRegex, valueUpdate: 'afterkeydown'" type="text" class="input-text" placeholder="e.g. (review|guide)">
                            <small class="form-text" style="display: block; margin-top: 1.125rem; color: #666;">
                                <span style="display: block;"><span class="form-label">EXAMPLES</span> <i>(case-insensitive, evaluated with PHP 'preg_match')</i>:</span>
                                <ul style="margin: .875rem 0 0; padding: 0; list-style: none;">
                                    <li style="margin-top: .4rem; display: flex; gap: .5rem; align-items: flex-start;"><span aria-hidden="true" style="flex: 0 0 auto; color: #555;">○</span><span>Include tags containing "review" or "guide": <code>(review|guide)</code></span></li>
                                    <li style="margin-top: .4rem; display: flex; gap: .5rem; align-items: flex-start;"><span aria-hidden="true" style="flex: 0 0 auto; color: #555;">○</span><span>Exclude tags containing "draft" or "internal": <code>^(?!.*(draft|internal))</code></span></li>
                                    <li style="margin-top: .4rem; display: flex; gap: .5rem; align-items: flex-start;"><span aria-hidden="true" style="flex: 0 0 auto; color: #555;">○</span><span>Include "review" but exclude "draft": <code>^(?=.*review)(?!.*draft)</code></span></li>
                                </ul>
                            </small>
                        </div>
                    </div>
                </div>

                <div class="w-form-body" data-bind="visible: contentType() === 'custom' ">
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">HTML</strong>
                        <div class="form-group">
                            <label for="" class="form-label">HTML</label>
                            <textarea style="height: 300px" id="htmlEditor" data-bind="value: html, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">CSS</strong>
                        <div class="form-group">
                            <label for="" class="form-label">CSS</label>
                            <textarea style="height: 300px" id="cssEditor" data-bind="value: css, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                </div>

                <div class="form-body" data-bind="visible: contentType() === 'custom' ">
                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group">
                            `+ this.vignettePreview.getHtmlBuild() +`
                        </div>
                    </div>
                </div>

                <div class="form-body" data-bind="visible: contentType() === 'preset' " style="padding-top: 0;">
                    <div class="w-form-body">
                        <div class="form-body" style="padding-top: 0;">
                            <strong class="form-sub-title no-margin">Presets</strong>
                            <div class="form-group">
                                <label for="name" class="form-label">Presets</label>
                                `+ this.presetsFilter.getHtmlBuild() +`
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filterLoginStatus = new filterDropdown_template("filterLoginStatus", this.getTemplateViewModel(), this.caller);
        this.filterLoginStatus.setLabel("Login User");
        this.filterLoginStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Is Logged In'}, {id : '0', name: 'Is Not Logged In'}]);

        this.filterPreimumStatus = new filterDropdown_template("filterPreimumStatus", this.getTemplateViewModel(), this.caller);
        this.filterPreimumStatus.setLabel("Premium User");
        this.filterPreimumStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Is Premium User'}, {id : '0', name: 'Is Not Premium User'}]);

        this.filterAdBlockStatus = new filterDropdown_template("filterAdBlockStatus", this.getTemplateViewModel(), this.caller);
        this.filterAdBlockStatus.setLabel("Ad Block User");
        this.filterAdBlockStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Has Ad Block'}, {id : '0', name: 'Does Not Have Ad Block'}]);

        this.filterBotRequestStatus = new filterDropdown_template("filterBotRequestStatus", this.getTemplateViewModel(), this.caller);
        this.filterBotRequestStatus.setLabel("Bot Request");
        this.filterBotRequestStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Is Bot Request'}, {id : '0', name: 'Is Not Bot Request'}]);

        this.filterListStatus = new filterDropdown_template("filterListStatus", this.getTemplateViewModel(), this.caller);
        this.filterListStatus.setLabel("List Item User");
        this.filterListStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Has 5 Or More Items in Lists'}, {id : '0', name: 'Has Less Than 5 Items in Lists'}]);

        this.filterPushNotificationStatus = new filterDropdown_template("filterPushNotificationStatus", this.getTemplateViewModel(), this.caller);
        this.filterPushNotificationStatus.setLabel("Push Notifications");
        this.filterPushNotificationStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Subscribed'}, {id : '0', name: 'Unsubscribed'}]);

        this.filterHighEngagementStatus = new filterDropdown_template("filterHighEngagementStatus", this.getTemplateViewModel(), this.caller);
        this.filterHighEngagementStatus.setLabel("High Engagement");
        this.filterHighEngagementStatus.setOptions([{id : 'null', name: 'Not Applied'}, {id : '1', name: 'Highly Engaged'}, {id : '0', name: 'Not Highly Engaged'}]);

        this.presetsFilter = new filterDropdown_template("presetsFilter", this.getTemplateViewModel(), this.caller);
        this.presetsFilter.setLabel("Presets");

        this.filterGEO = new filterAutocomplete_template("filterAutocompleteGEO_template", this.getTemplateViewModel(), this.caller);
        this.filterGEO.setAddNewOptionEnabled(false);
        this.filterGEO.setHasDisplayNameComplement(false);
        this.filterGEO.setIsShowCurrentSelection(false);
        this.filterGEO.setNumberOfChars(1);
        this.filterGEO.setPlaceholderAndLabel("GEO");

        this.vignettePreviewHelper = new vignettePreview_helper(this.caller.getVnAppZone(), this.caller);
        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.vignettePreviewHelper);
        this.vignettePreview.setShowKeys(true);
        this.vignettePreviewHelper.initializeBrandDefaults();
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "static"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            isAvailable: ko.observable(true),
            htmlValue: ko.observable(""),
            html: ko.pureComputed(this.htmlComputed(self)),
            cssValue: ko.observable(""),
            css: ko.pureComputed(this.cssComputed(self)),
            contentType: ko.observable("custom"),
            tagNameRuleRegex: ko.observable(""),
            geos: ko.observableArray([]),
            zones: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(['config_promotion'])),
            onClickCancel: function (data, event) {
                self.onClickCancel();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
            onClickRemoveGeo: function (data) {
                self.onClickRemoveGeo(data)
            }
        }
    }


    protected getTemplateName(): string {

        return "configPromotionEdit_template";
    }

    public getViewModelForRequest() {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            isAvailable: this.getTemplateViewModel().isAvailable(),
            isLoginUser: this.filterLoginStatus.getTemplateViewModel().selectedOption,
            isPremiumUser: this.filterPreimumStatus.getTemplateViewModel().selectedOption,
            isAdBlockUser: this.filterAdBlockStatus.getTemplateViewModel().selectedOption,
            isBotRequest: this.filterBotRequestStatus.getTemplateViewModel().selectedOption,
            has5ListItemsOrMore: this.filterListStatus.getTemplateViewModel().selectedOption,
            isPushNotificationSubscribed: this.filterPushNotificationStatus.getTemplateViewModel().selectedOption,
            isHighlyEngaged: this.filterHighEngagementStatus.getTemplateViewModel().selectedOption,
            html: this.getTemplateViewModel().html(),
            css: this.getTemplateViewModel().css(),
            contentType: this.getTemplateViewModel().contentType(),
            idPreset: this.presetsFilter.getTemplateViewModel().selectedOption,
            tagNameRuleRegex: this.getTemplateViewModel().tagNameRuleRegex(),
            geos: this.getTemplateViewModel().geos()
        }
    }

    protected htmlComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().htmlValue();
            },
            write: function(value) {
                self.getTemplateViewModel().htmlValue(value);
                self.vignettePreview.setHtml(value);
            }
        }
    }

    protected cssComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().cssValue();
            },
            write: function(value) {
                self.getTemplateViewModel().cssValue(value);
                self.vignettePreview.setCss(value);
            }
        }
    }

    public setZones(zones){

        this.getTemplateViewModel().zones(zones);
    }

    public setPresetOptions(presets){

        //add the default preset
        presets.unshift({id : '', name: 'Select Preset'});
        this.presetsFilter.setOptions(presets);
    }

    public setFilterConfig(filterConfig){

        let config = filterConfig || {};
        this.getTemplateViewModel().tagNameRuleRegex(config.tagNameRuleRegex || "");
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setId(id){

        this.getTemplateViewModel().id(id)
    }
    public setName(name){

        this.getTemplateViewModel().name(name)
    }

    public setIsAvailable(isAvailable){

        this.getTemplateViewModel().isAvailable(isAvailable)
    }

    public setLoginStatus(status){

        this.filterLoginStatus.setSelectedOption(status);
    }

    public setPremiumStatus(status){

        this.filterPreimumStatus.setSelectedOption(status);
    }

    public setAdBlockStatus(status){

        this.filterAdBlockStatus.setSelectedOption(status);
    }

    public setBotRequestStatus(status) {

        this.filterBotRequestStatus.setSelectedOption(status);
    }

    public setListItemStatus(status){

        this.filterListStatus.setSelectedOption(status);
    }

    public setPushNotificationStatus(status){

        this.filterPushNotificationStatus.setSelectedOption(status);
    }

    public setHighEngagementStatus(status){

        this.filterHighEngagementStatus.setSelectedOption(status);
    }

    public setHtml(htmlValue){

        this.getTemplateViewModel().htmlValue(htmlValue);
        this.vignettePreview.setHtml(htmlValue);
    }

    public setCss(cssValue){

        this.getTemplateViewModel().cssValue(cssValue);
        this.vignettePreview.setCss(cssValue);
    }

    public setContentType(contentType){

        this.getTemplateViewModel().contentType(contentType);
    }

    public setPreset(preset){

        this.presetsFilter.setSelectedOption(preset.id);
    }

    public setGeos(geos){

        this.getTemplateViewModel().geos(geos || []);
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel();
    }

    protected onClickSave(): any {

        this.caller.save()
    }

    protected onClickRemoveGeo(data): any {

        let geos = this.getTemplateViewModel().geos();
        let newGeos = geos.filter((geo) => geo.id != data.id);
        this.getTemplateViewModel().geos(newGeos);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configPromotionsEdit_template.ts